// extracted by mini-css-extract-plugin
export default {"caption":"ggt3jKgM","blockContent":"M4VYFwbm","infoBlock":"t8LF5gHZ","mobile":"mobile"};